import { render, staticRenderFns } from "./FormProductBasicLocale.vue?vue&type=template&id=6ade926c&scoped=true&"
import script from "./FormProductBasicLocale.vue?vue&type=script&lang=js&"
export * from "./FormProductBasicLocale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade926c",
  null
  
)

export default component.exports